import axios from 'axios';
import { entityServices } from '../services/entityServices';
import { entityConstants } from '../constants';


export const entityActions = {
    getEntities,
    createEntity,
    updateEntity,
    deleteEntity,
    createRootEntity,
    reorderEntities,
};

function getEntities(options = {}) {
    return async (dispatch, getState) => {
        if (!options.force && getState().entities && getState().entities.entities) return;
        dispatch(request());

        try {
            const response = await axios.get('/entities');

            if (response.status === 200) dispatch(success(response.data));
            if (response.status === 500) dispatch(failure(response.data.toString()));
        } catch (error) {
            console.error(error);
            if (error.response) {
                dispatch(failure(error.response.data.toString()));
            } else {
                dispatch(failure('Unable to update account structure at this moment. Please try again later.'));
            }
        }
    };

    function request() {
         return { type: entityConstants.GET_ENTITY_REQUEST };
    }
    function success(entities) {
        return { type: entityConstants.GET_ENTITY_SUCCESS, entities };
    }
    function failure(error) {
        return { type: entityConstants.GET_ENTITY_FAILURE, error };
    }
}

const findEntityById = (list, id) => {
  if (!Array.isArray(list)) return null;
    for (const ent of list) {
        if (Number(ent.entity_id) === Number(id)) return ent;
        const found = findEntityById(ent.children || [], id);
        if (found) return found;
    }
    return null;
};

function createEntity(parentEntityId) {
    return async (dispatch, getState) => {
        dispatch(request());

        try {
             
            const entityStructure = [...getState().entities.entities];
            const parentEntity =
            parentEntityId == null ? null : findEntityById(entityStructure, parentEntityId);
                 
            const response = await axios.post('/entities/' , {
                
                name: 'New Unit',
                parent: parentEntityId,
                key: entityServices.createNewKey(parentEntity, entityStructure),
            });

            if (response.status === 201) {
                const newEntity = { ...response.data, ...{ scenario: [] } };
                
                if (parentEntityId != null) {
                    entityServices.insertNewSubEntity(newEntity, entityStructure);
                } else {
                    entityStructure.push(newEntity);
                }
                dispatch(success(entityStructure));
                return newEntity;
            }
            if (response.status === 500) dispatch(failure(response.data.toString()));
        } catch (error) {
            console.error(error);
            if (error.response) {
                dispatch(failure(error.response.data.toString()));
            } else {
                dispatch(failure('Unable to update account structure at this moment. Please try again later.'));
            }
        }
    };

    function request() {
        return { type: entityConstants.CREATE_ENTITY_REQUEST };
    }
    function success(entities) {
        return { type: entityConstants.CREATE_ENTITY_SUCCESS, entities };
    }
    function failure(error) {
        return { type: entityConstants.CREATE_ENTITY_FAILURE, error };
    }
}

export function createRootEntity(name = 'New Group') {
  return async (dispatch) => dispatch(createEntity(null, name));
}

function updateEntity(entity, newName) {
    return async (dispatch, getState) => {
        dispatch(request());

        try {
            let url = '/entities/' + entity.entity_id;

            const response = await axios.put(url, {
                name: newName,
                key: entity.key,
            });

            if (response.status === 200) {
                const updatedEntity = response.data;

                const entityStructure = [...getState().entities.entities];
                entityServices.updateUpdatedEntity(updatedEntity, entityStructure);

                dispatch(success(entityStructure));
            }
            if (response.status === 500) dispatch(failure(response.data.toString()));
        } catch (error) {
            console.error(error);
            if (error.response) {
                dispatch(failure(error.response.data.toString()));
            } else {
                dispatch(failure('Unable to update account structure at this moment. Please try again later.'));
            }
        }
    };

    function request() {
        return { type: entityConstants.UPDATE_ENTITY_REQUEST };
    }
    function success(entities) {
        return { type: entityConstants.UPDATE_ENTITY_SUCCESS, entities };
    }
    function failure(error) {
        return { type: entityConstants.UPDATE_ENTITY_FAILURE, error };
    }
}

function deleteEntity(entity) {
    return async (dispatch, getState) => {
        dispatch({ type: entityConstants.DELETE_ENTITY_REQUEST });

        try {
            const ids = { entityIds: [], scenarioIds: [] };
            entityServices.findEntityIDs(ids, [entity]);

            const response = await axios.delete('/entities', {
                data: { ids: ids.entityIds },
            });

            if (response.status === 200) {
                const deletedEntityId = +response.data;

                // Update entity tree
                const newEntityStructure = [...getState().entities.entities];
                entityServices.removeDeletedEntity(deletedEntityId, newEntityStructure);

                // Remove all scenarios belonging to deleted entity subtree
                const newScenarios = new Map(getState().scenarios.scenarios);
                ids.scenarioIds.forEach((id) => {
                    newScenarios.delete(String(id)); // always String — matches Map keys
                    newScenarios.delete(Number(id)); // belt-and-suspenders for mixed key types
                });

                // Check if currentScenario was in the deleted subtree
                const current = getState().scenarios.currentScenario;
                const currentWasDeleted = current &&
                    ids.scenarioIds.some(id => Number(id) === Number(current.scenario_id));

                // Single dispatch carries everything
                dispatch({
                    type:               entityConstants.DELETE_ENTITY_SUCCESS,
                    entities:           newEntityStructure,
                    scenarios:          newScenarios,
                    clearCurrentScenario: currentWasDeleted,
                });
            }

            if (response.status === 500) {
                dispatch({
                    type:  entityConstants.DELETE_ENTITY_FAILURE,
                    error: response.data.toString(),
                });
            }

        } catch (error) {
            console.error(error);
            dispatch({
                type:  entityConstants.DELETE_ENTITY_FAILURE,
                error: error.response
                    ? error.response.data.toString()
                    : 'Unable to delete entity at this moment. Please try again later.',
            });
        }
    };
}

export function reorderEntities(parent, orderedIds) {
  return async (dispatch, getState) => {
    const snapshot = getState().entities.entities;
    const parentId = parent == null ? null : Number(parent);
    const ids = orderedIds.map(Number);

    // REQUEST carries the optimistic reorder
    dispatch({ type: entityConstants.REORDER_ENTITIES_REQUEST, parent: parentId, orderedIds: ids });

    try {
      const { data } = await axios.put('/entities/reorder', {
        parent: parentId,
        ordered_ids: ids,
      });
      dispatch({ type: entityConstants.REORDER_ENTITIES_SUCCESS, entities: data.entities });
      return data.entities;
    } catch (err) {
      // FAILURE carries the snapshot to roll back to
      dispatch({ type: entityConstants.REORDER_ENTITIES_FAILURE, entities: snapshot, error: err });
      throw err;
    }
  };
}

